const config = {
  gatsby: {
    pathPrefix: '/docs',
    siteUrl: 'https://designerbox.ai',
    gaTrackingId: 'G-JMWTYR7TGG',
    trailingSlash: false,
  },
  404: {
    title: 'Documentation | DesignerBox',
    description: 'Documentation built with mdx. ',
  },
  header: {
    logo: 'https://d1yvlcprw8y65e.cloudfront.net/logo/logo-long-white.svg',
    logoLink: 'https://designerbox.ai/',
    title: "<a class='header-link' href='https://designerbox.ai/docs/'>" +
      "<span class='header-link-separator'></span>" +
      "<span class='header-link-text'>docs</span>" +
      "</a>",
    githubUrl: '',
    helpUrl: '',
    tweetText: '',
    social: ``,
    links: [
      { text: 'Pricing', link: 'https://designerbox.ai/pricing' },
      { text: 'Blog', link: 'https://designerbox.ai/blog/' },
      { text: 'Login', link: 'https://designerbox.ai/login' },
      { text: 'Sign Up', link: 'https://designerbox.ai/signup' },
    ],
    search: {
      enabled: true,
      indexName: 'Docs',
      algoliaAppId: 'P2AFM9NVH7',
      algoliaSearchKey: '6bdb42dca3597a9cddf7efe5a2fbf7bb',
      algoliaAdminKey: process.env.ALGOLIA_ADMIN_KEY || '',
    },
  },
  sidebar: {
    forcedNavOrder: [
      '/guides',
      '/features',
      '/integrations',
      '/knowledge-base',
      '/pricing',
    ],
    collapsedNav: [
      '/knowledge-base',
    ],
    links: [
      { text: 'Get Started Now', link: 'https://designerbox.ai/pricing' },
    ],
    linksNormal: [
      { text: '© DesignerBox - Privacy Policy', link: 'https://designerbox.ai/privacy' },
    ],
    frontline: false,
    ignoreIndex: true,
    title: false,
  },
  siteMetadata: {
    title: 'Documentation | DesignerBox',
    description: 'DesignerBox Documentation.',
    ogImage: 'https://designerbox.ai/ogimage.jpg',
    docsLocation: '',
    favicon: 'https://designerbox.ai/favicon.ico',
  },
  pwa: {
    enabled: false, // disabling this will also remove the existing service worker.
    manifest: {
      name: 'DesignerBox Documentation',
      short_name: 'DesignerBox Docs',
      start_url: '/',
      background_color: '#f71ec7',
      theme_color: '#f71ec7',
      display: 'standalone',
      crossOrigin: 'use-credentials',
      icons: [
        {
          src: 'src/pwa-512.png',
          sizes: `512x512`,
          type: `image/png`,
        },
      ],
    },
  },
};

module.exports = config;
